import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../assets/detail.svg'
import _imports_1 from '../assets/loading.gif'


const _hoisted_1 = {
  key: 0,
  class: "l-modal"
}
const _hoisted_2 = { class: "form" }
const _hoisted_3 = {
  key: 0,
  class: "information"
}
const _hoisted_4 = {
  key: 1,
  class: "mypage__list"
}
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "footer" }
const _hoisted_9 = { key: 1 }

import { useRouter } from "vue-router";
import { onMounted, ref } from "vue";
import liff from "@line/liff";
import { UserInfoStore } from "../store/UserInfoStore";
import { ProjectStore } from "../store/ProjectStore";

import { signIn } from "../services/UserInfoService";
interface Emits {
  (e: "update:modelValue", value: boolean): void;
}
export type ModalProps = {
  modelValue: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'RegistModal',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const regist = ref(false);
const loading = ref(true);
const router = useRouter();
const userInfoStore = UserInfoStore();
const projectStore = ProjectStore();

const emit = __emit;

function isChecked() {
  const res = itemList.value.find((v) => v.checked == false);
  if (res) return false;
  else return true;
}
function cancel() {
  // windowを閉じる
  liff.closeWindow();
}

// ページ遷移
function push(link: boolean, page: string) {
  if (link) {
    window.open(page);
  } else {
    router.push(page);
  }
}

async function agree() {
  // lineのトークンの情報だけ登録
  loading.value = true;
  await userInfoStore
    .signUp()
    .then(async () => {
      await signIn(true)
      await userInfoStore.getUserDetail();
      await projectStore.getNotification()
      await userInfoStore.getBankInfo()
      await userInfoStore.getUserSnsAccount()
    }).then(() => {
      loading.value = false;
      emit("update:modelValue", false);
    });
}

const itemList = ref([
  { name: "利用規約", page: "/terms-of-use", link: false, checked: false },
  {
    name: "プライバシーポリシー",
    page: "https://fisminc.com/privacy-policy/",
    link: true,
    checked: false,
  },
]);

onMounted(async () => {
  loading.value = false;
});



return (_ctx: any,_cache: any) => {
  return (_ctx.modelValue)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass([regist.value ? '' : 'l-modal__bg'])
        }, null, 2 /* CLASS */),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (cancel()))
          }),
          (_ctx.modelValue)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[2] || (_cache[2] = [
                _createElementVNode("p", null, "OMOT Influencerをご利用になる前に", -1 /* HOISTED */),
                _createElementVNode("p", null, "利用規約及びプライバシーポリシーを確認の上、", -1 /* HOISTED */),
                _createElementVNode("p", null, "同意が必要です", -1 /* HOISTED */)
              ])))
            : _createCommentVNode("v-if", true),
          (!loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "list__item"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      id: "checkbox",
                      "onUpdate:modelValue": ($event: any) => ((item.checked) = $event),
                      name: "checkbox",
                      type: "checkbox",
                      style: {"margin-right":"30px"}
                    }, null, 8 /* PROPS */, _hoisted_5), [
                      [_vModelCheckbox, item.checked]
                    ]),
                    _createElementVNode("p", {
                      onClick: ($event: any) => (push(item.link, item.page))
                    }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_6),
                    _createElementVNode("img", {
                      class: "detail_icon",
                      src: _imports_0,
                      onClick: ($event: any) => (push(item.link, item.page))
                    }, null, 8 /* PROPS */, _hoisted_7)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_8, [
            (!loading.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["btn", [isChecked() ? 'active' : 'inactive']]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (isChecked() ? agree() : ''))
                }, _cache[3] || (_cache[3] = [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, "利用規約とプライバシーポリシーに"),
                    _createElementVNode("p", null, "同意する")
                  ], -1 /* HOISTED */)
                ]), 2 /* CLASS */))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[4] || (_cache[4] = [
                  _createElementVNode("img", {
                    src: _imports_1,
                    class: "loading"
                  }, null, -1 /* HOISTED */)
                ])))
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})